import { render, staticRenderFns } from "./ComplexOfficeWrite.vue?vue&type=template&id=47b730d5&scoped=true"
import script from "./ComplexOfficeWrite.vue?vue&type=script&lang=js"
export * from "./ComplexOfficeWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b730d5",
  null
  
)

export default component.exports